<div class="default">
  <div *ngIf="hintLevel === 3"><h2>warning</h2></div>
  <div><ng-content></ng-content></div>
  <div class="default__buttons">
    <button class="primary" (click)="acknowledgeHint()">got it</button>
  </div>
</div>
